'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileOrTabletSafari = exports.isMobileOrTablet = undefined;

var _uaParserJs = require('ua-parser-js');

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parser = new _uaParserJs2.default();

var isMobileDevice = function isMobileDevice() {
  return typeof window !== 'undefined' && parser.getDevice().type === 'mobile';
};
var isTabletDevice = function isTabletDevice() {
  return typeof window !== 'undefined' && parser.getDevice().type === 'tablet';
};

var getBrowser = function getBrowser() {
  var _parser$getResult = parser.getResult(),
      browser = _parser$getResult.browser;

  return browser;
};

var isMobileOrTablet = exports.isMobileOrTablet = isMobileDevice() || isTabletDevice();
var isMobileOrTabletSafari = exports.isMobileOrTabletSafari = typeof window !== 'undefined' && isMobileOrTablet && getBrowser().name.includes('Safari');


//////////////////
// WEBPACK FOOTER
// ./node_modules/body-scroll-lock/lib/utils/userAgent.js
// module id = 658
// module chunks = 0 1 2 3 4